
import React from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import UnifiedRequestForm from '@/components/feedback/UnifiedRequestForm';

const RequestFeedbackUnified = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow bg-gray-50 py-6">
        <UnifiedRequestForm />
      </main>
      <Footer />
    </div>
  );
};

export default RequestFeedbackUnified;
